import React from "react";
import { isMobile } from "react-device-detect";
import { useQuery } from "@apollo/client";
import DesktopHeader from "../../Header/DesktopHeader";
import MobileHeader from "../../Header/MobileHeader";
import DeskFooter from "../DeskFooter";
import MobileFooter from "../MobileFooter";

import { PRIVACY_POLICY } from "../../../gqlOperations/queries";

export default function PrivacyPolicy() {
  document.title = "Privacy Policy | KheloMore";
  const { loading, error, data } = useQuery(PRIVACY_POLICY);
  const htmlData = data?.privacyPolicies?.data.map(
    (details) => details?.attributes?.Value
  );
  return (
    <>
      {isMobile ? (
        <div>
          <MobileHeader />
          <div>
            <div dangerouslySetInnerHTML={{ __html: htmlData }} />
          </div>
          <div style={{ width: "90%", margin: "20px 14px" }}>
            <h2
              style={{
                fontSize: "14px",
                fontWeight: "700",
                marginTop: "-32px",
              }}
            >
              WhatsApp Policy
            </h2>
            <p>&nbsp;</p>
            <p style={{ fontSize: "14px", paddingBottom: "32px",lineHeight:"1.5" }}>
              We use WhatsApp to send booking confirmations, OTPs, and updates
              to users who have opted in.
            </p>
          </div>
          {/* <MobileFooter />     */}
        </div>
      ) : (
        <div>
          <DesktopHeader />
          <div>
            <div dangerouslySetInnerHTML={{ __html: htmlData }} />
          </div>
          <div style={{ width: "55%", margin: "0 auto" }}>
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "700",
                marginTop: "-32px",
              }}
            >
              WhatsApp Policy
            </h2>
            <p>&nbsp;</p>
            <p style={{ fontSize: "14px", paddingBottom:"64px" }}>
              We use WhatsApp to send booking confirmations, OTPs, and updates
              to users who have opted in.
            </p>
          </div>
          <DeskFooter />
        </div>
      )}
    </>
  );
}
